import { map } from 'lodash';
import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { FinancialAccount } from '/@/modules/financialaccount/models/FinancialAccount';
import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';

export class FinancialAccountResource extends BaseResource {
  /**
   * @param {FinancialAccount[]} financialAccounts
   * @param {FinancialAccount} manualAccountToEnable
   * @returns {*}
   */
  unlink(financialAccounts, manualAccountToEnable) {
    return this.postData(Route.FINANCIAL_ACCOUNTS_UNLINK, {
      financial_account_ids: map(financialAccounts, 'id'),
      manual_account_to_enable: manualAccountToEnable
    });
  }

  /**
   * @param {FinancialInstitution} financialInstitution
   * @returns {*}
   */
  updateBalances(financialInstitution = null) {
    return this.postData(Route.FINANCIAL_ACCOUNTS_UPDATE_BALANCES, {
      financial_institution_id: financialInstitution?.id
    });
  }

  /**
   * @param {FinancialAccount} financialAccount
   * @returns {*}
   */
  updateBalance(financialAccount) {
    return this.postData(Route.FINANCIAL_ACCOUNTS_UPDATE_BALANCE, {
      financial_account_id: financialAccount.id
    });
  }

  /**
   * @param {number} financialGatewayTokenId
   * @param {object} params
   * @returns {*}
   */
  getConnectedAccounts(financialGatewayTokenId, params = {}) {
    return this.getData(Route.FINANCIAL_ACCOUNTS_CONNECTED, FinancialAccount, {
      ...params,
      financial_gateway_token_id: UrlQueryOperator.toEncrypted(financialGatewayTokenId)
    });
  }

  /**
   * @returns {Promise<*>}
   */
  async getEstateBankAccount(is_disabled = false) {
    return this.getData(Route.FINANCIAL_ACCOUNTS_ESTATEBANKACCOUNT, FinancialAccount, {
      is_disabled: is_disabled
    });
  }
}

export default new FinancialAccountResource();
